export default __webpack_public_path__ + "static/media/185.372962b7.gif";